import { ONBOARDING_AGENT_AI_GRADIENT_COLORS } from "../onboardingAgentAiGradientTokens";

export const MAX_TEXTAREA_HEIGHT_PX = 120;
export const COMPOSER_TEXTAREA_ROWS = 1;
export const COMPOSER_TEXTAREA_AUTO_HEIGHT = "auto";

export const SEND_BUTTON_SIZE_PX = 32;
export const SEND_BUTTON_BORDER_RADIUS_PX = 50;
export const STOP_ICON_SIZE_PX = 10;
export const STOP_ICON_BORDER_RADIUS_PX = 2;

export const SEND_GRADIENT_ANGLE = "90.24deg";
export const SEND_GRADIENT_START_OFFSET = "0.21%";
export const SEND_GRADIENT_END_OFFSET = "99.79%";
export const SEND_GRADIENT_START_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.defaultStart;
export const SEND_GRADIENT_END_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.defaultEnd;
export const SEND_GRADIENT_HOVER_START_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.hoverStart;
export const SEND_GRADIENT_HOVER_END_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.hoverEnd;
export const SEND_GRADIENT_ACTIVE_START_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.activeStart;
export const SEND_GRADIENT_ACTIVE_END_COLOR = ONBOARDING_AGENT_AI_GRADIENT_COLORS.activeEnd;
